import client from '../client';

export type TApiCountry = {
  code: string;
  title: string;
}

const list = (): Promise<Array<TApiCountry>> =>
  client.get('/country/').then(response => response.data);

export {
  list
};
